export default "__VITE_ASSET__CBxUcINm__"